import NutritionConfig from '../preemie-nutrition/NutritionConfig';

/**
 * Admin console for the "הזנה בטיפול נמרץ ילדים" app (`NICU_NUTRITION`).
 * Shares the whole UI with the תזונת פגים console — only the AppConfig identity differs,
 * so each app keeps its own formulas per hospital.
 */
const NicuNutritionConfig = () => (
    <NutritionConfig
        appName="NICU_NUTRITION"
        configName="nutrition-values"
        title="ניהול הזנה בטיפול נמרץ ילדים"
        appUrl="https://my.mashlom.me/main/apps/nicu-nutrition"
    />
);

export default NicuNutritionConfig;
